const initialContext = {
  brandAssetsURL: null,
  talkdeskIdAssetsURL: null,
  csrfToken: null,
  tenantId: '',
  splitIoKeyUI: '',
  passwordPolicies: null,
  showGoogleFooterLink: true,
  branding: {
    name: '',
    copyright: '',
    assets: { 'base-url': '', logos: { regular: { svg: '' } } },
  },
  links: {
    support: '',
    'service-terms': '',
    'privacy-policy': '',
    'google-api-services': '',
  },
}

const branding = document.brandingSettings || {}

const context = document.context || {}

// initialContext's `branding`/`links` defaults must survive even when
// document.context is set, since document.context never carries branding
// (that comes from document.brandingSettings, set by a separate script
// that can still be slow or fail) — modules like ui.labels.js destructure
// `.branding` at import time and would throw on undefined otherwise.
export default {
  ...initialContext,
  ...context,
  ...branding,
}
